import React, { useEffect } from 'react';
import { Spinner } from '../../../../common/';
import SliderForm from './SliderForm.jsx';
import { routes } from '../../../../../utils/helpers/ApiClient';
import { AppBarCMS } from '../../../../basic';
import { useTranslation } from 'react-i18next';
import { useParams, useNavigate } from 'react-router-dom';
import { useToastMessages } from '../../../../../hooks/useToastMessages';
import {
  useGetSliderQuery,
  useGetSlidersQuery,
  useSaveSliderMutation,
} from '../../../../../redux/services/sliders';
import { Form as AntdForm } from 'antd';

const SlidersEdit = ({ mode }) => {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const isCreate = mode === 'create';
  const isEdit = mode === 'edit';

  useEffect(() => {
    document.title = isEdit
      ? `${t('Úprava baneru')} - FRI CMS`
      : `${t('Pridanie baneru')} - FRI CMS`;
  }, []); // Runs on mount

  const { data: sliderDetail, isLoading: sliderLoading } = !isCreate
    ? useGetSliderQuery(id)
    : { data: undefined, isLoading: false };

  const [saveSlider, { isSuccess: isSaveSuccess }] = useSaveSliderMutation();

  const { refetch } = useGetSlidersQuery();
  const [form] = AntdForm.useForm();

  const { saveSuccess: showSaveSuccess } = useToastMessages();

  useEffect(() => {
    if (isSaveSuccess) {
      showSaveSuccess();
      navigate(routes.cmsSliders);
      refetch();
    }
  }, [isSaveSuccess]);

  const initials = {
    target_url: sliderDetail?.target_url,
    meta_name: sliderDetail?.meta_name,
    active: sliderDetail?.active ?? true,
    image: sliderDetail?.image,
    image_object: sliderDetail?.image_object,
  };

  return !isCreate && sliderLoading ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={isCreate ? t('Pridanie banera') : t('Úprava banera')}
        backUrl={routes.cmsSliders}
        backUrlTooltip={t('Všetky obrázky')}
        permissionsBasic={'sliders'}
      />
      <div style={{ margin: '10px' }}>
        <SliderForm
          form={form}
          initialValues={initials}
          onFinish={(values) => {
            const updatedValues = {
              ...values,
              image:
                typeof values.image_object === 'object'
                  ? '/storage/sliders/' + values.image_object.name
                  : values.image_object,
            };
            isCreate
              ? saveSlider({ body: updatedValues })
              : saveSlider({ body: updatedValues, id: id });
          }}
        ></SliderForm>
      </div>
    </>
  );
};

export default SlidersEdit;
